export enum LeaveEligibilities {
    Eligible = -1,
    Ineligible = -2
}

export enum IneligibilityReasons {
    Other = -1
}